<template>
  <div class="flex-column">
    <sticky :className="'sub-navbar'">
      <div class="filter-container">
        <el-input @keyup.enter.native="handleFilter" size="mini" style="width: 200px;" class="filter-item"
          :placeholder="'关键字'" v-model="listQuery.key"> </el-input>
        <el-button class="filter-item" size="mini" v-waves icon="el-icon-search" @click="handleFilter">搜索</el-button>
        <permission-btn size="mini" v-on:btn-event="onBtnClicked"></permission-btn>
      </div>
    </sticky>
    <div class="app-container flex-item">
      <div class="bg-white" style="height: 100%;">
        <auth-table style="height:calc(100% - 60px)" ref="mainTable" :select-type="'checkbox'"
          :table-fields="headerList" :data="list" :v-loading="listLoading" @row-click="rowClick"
          @selection-change="handleSelectionChange"></auth-table>
        <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
          @pagination="handleCurrentChange" />
      </div>
      <!-- <el-dialog v-el-drag-dialog class="dialog-mini" width="500px" :title="textMap[dialogStatus]"
        :visible.sync="dialogFormVisible">
        <auth-form ref="dataForm" :rules="rules" :edit-model="true" :form-fields="headerList" v-model="temp"
          :col-num="1"></auth-form>
        <div slot="footer">
          <el-button size="mini" @click="dialogFormVisible = false">取消</el-button>
          <el-button size="mini" v-if="dialogStatus == 'create'" type="primary" @click="createData">确认</el-button>
          <el-button size="mini" v-else type="primary" @click="updateData">确认</el-button>
        </div>
      </el-dialog> -->


      <el-dialog v-el-drag-dialog class="dialog-mini" width="500px" :title="textMap[dialogStatus]"
        :visible.sync="dialogFormVisible" v-loading>
        <el-form ref="dataForm" :rules="rules" :model="temp" label-position="right" label-width="120px"
          style="height:calc(100% - 34px);overflow: auto;">
          <el-row>
            <el-col :span="24">
              <el-form-item size="mini" label="App" prop="app">
                <el-select filterable allow-create clearable size="mini" v-model="temp['app']">
                  <el-option :key="'TL2001'" :value="'TL2001'" :label="'TL2001'"></el-option>
                  <el-option :key="'TL2001-Test'" :value="'TL2001-Test'" :label="'TL2001-Test'"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item size="mini" label="内部版本号" prop="buildNumber">
                <el-input type="number" v-model="temp['buildNumber']"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item size="mini" label="版本号" prop="version">
                <el-input type="text" v-model="temp['version']"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item size="mini" label="发布时间" prop="releaseDate">
                <el-date-picker type="datetime" v-model="temp['releaseDate']" style="width: 185px;"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item size="mini" label="安装包" prop="apkUrl">
                <el-upload ref="upload" accept=".apk" :multiple="false" :action="uploadUrl"
                  :headers="headers" :limit="1" :file-list="fileList" :before-upload="checkFileType"
                  :on-error="handleUpload" :on-success="handleUpload"
                  :on-remove="handleFileRemove"
                  :show-file-list='true' :auto-upload="true">
                  <el-button slot="trigger" size="small" type="primary" :disabled="!enableFileBtn">选取文件</el-button>
                  <div slot="tip" class="el-upload__tip">只能上传apk文件</div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item size="mini" label="发布说明" prop="releaseNotes">
                <el-input type="textarea" v-model="temp['releaseNotes']"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer">
          <el-button size="mini" @click="dialogFormVisible = false">取消</el-button>
          <el-button size="mini" v-if="dialogStatus == 'create'" type="primary" @click="createData">确认</el-button>
          <el-button size="mini" v-else type="primary" @click="updateData">确认</el-button>
        </div>
      </el-dialog>

    </div>
  </div>
</template>
<script>
import * as androidApps from '@/api/androidApps'
import waves from '@/directive/waves' // 水波纹指令
import Sticky from '@/components/Sticky'
import permissionBtn from '@/components/PermissionBtn'
import Pagination from '@/components/Pagination'
import elDragDialog from '@/directive/el-dragDialog'
import { defaultVal } from '@/utils/index'
import extend from '@/extensions/common.js'
import AuthTable from '../../components/Base/AuthTable.vue'
import ColumnDefine from '@/interface/columnDefine'
import { getToken } from '@/utils/auth'

export default {
  name: 'androidApp',
  components: { Sticky, permissionBtn, Pagination, AuthTable, },
  directives: {
    waves,
    elDragDialog,
  },
  mixins: [extend],
  data() {
    return {
      headers: {
        'X-Token': getToken()
      },
      uploadUrl: process.env.VUE_APP_BASE_API + '/Android/Upload',
      fileLoading: null,
      enableFileBtn: true,
      fileList: [],
      headerList: [], // 主列表列定义
      multipleSelection: [], // 列表checkbox选中的值
      tableKey: 0,
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        // 查询条件
        page: 1,
        limit: 20,
        key: undefined,
      },
      temp: {},
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '添加',
      }
    }
  },
  created() {
    this.headerList = [
      new ColumnDefine('id', 'Id', false, false, '', '', 'bigint', 'bigint', 'Id'),
      new ColumnDefine('app', 'App', true, true, 'select', [{ value: 'TL2001', label: 'TL2001' },{ value: 'TL2001-Test', label: 'TL2001-Test' }], 'string', 'varchar', 'App'),
      new ColumnDefine('version', '版本号', true, true, 'text', '', 'string', 'varchar', 'Version'),
      new ColumnDefine('buildNumber', '内部版本号', true, true, 'number', '', 'int', 'int', 'BuildNumber'),
      new ColumnDefine('releaseDate', '发布时间', true, true, 'datetime', '', 'DateTime', 'datetime', 'ReleaseDate'),
      new ColumnDefine('releaseNotes', '发布说明', true, false, 'textarea', '', 'string', 'text', 'ReleaseNotes'),
      new ColumnDefine('apkUrl', '下载地址', false, true, 'text', '', 'string', 'varchar', 'ApkUrl'),

    ]
    this.getList()
  },
  computed: {
    rules() {
      if (this.dialogStatus == "create") {
        return {
          app: [{ required: true, message: 'App不能为空', trigger: 'blur' }],
          version: [{ required: true, message: '版本号不能为空', trigger: 'blur' }],
          buildNumber: [{ required: true, message: '内部版本号不能为空', trigger: 'blur' }],
          releaseDate: [{ required: true, message: '发布时间不能为空', trigger: 'blur' }],
          releaseNotes: [{ required: true, message: '发布说明不能为空', trigger: 'blur' }],
          apkUrl: [{ required: true, message: '必须上传软件包', trigger: 'blur' }],
        };
      } else {
        return {
          app: [{ required: true, message: 'App不能为空', trigger: 'blur' }],
          version: [{ required: true, message: '版本号不能为空', trigger: 'blur' }],
          buildNumber: [{ required: true, message: '内部版本号不能为空', trigger: 'blur' }],
          releaseDate: [{ required: true, message: '发布时间不能为空', trigger: 'blur' }],
          releaseNotes: [{ required: true, message: '发布说明不能为空', trigger: 'blur' }],
        };
      }
    }
  },
  methods: {

    rowClick(row) {
      this.$refs.mainTable.clearSelection()
      this.$refs.mainTable.toggleRowSelection(row)
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    onBtnClicked: function (domId, callback) {
      this.$refs.upload?.clearFiles();
      this.enableFileBtn=true;
      console.log('you click:' + domId)
      switch (domId) {
        case 'btnAdd':
          this.handleCreate()
          break
        case 'btnEdit':
          if (this.multipleSelection.length !== 1) {
            this.$message({
              message: '只能选中一个进行编辑',
              type: 'error',
            })
            return
          }
          this.handleUpdate(this.multipleSelection[0])
          break
        case 'btnDel':
          if (this.multipleSelection.length < 1) {
            this.$message({
              message: '至少删除一个',
              type: 'error',
            })
            return
          }
          this.handleDelete(this.multipleSelection)
          break
        case 'btnExport':
          this.$refs.mainTable.exportExcel('资源文件', callback)
          break
        default:
          break
      }
    },
    getList() {
      this.listLoading = true
      androidApps.getList(this.listQuery).then((response) => {
        this.list = response.data
        this.total = response.count
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val.page
      this.listQuery.limit = val.limit
      this.getList()
    },
    handleModifyStatus(row, disable) {
      // 模拟修改状态
      this.$message({
        message: '操作成功',
        type: 'success',
      })
      row.disable = disable
    },
    resetTemp() {
      let obj = {};
      this.headerList.forEach((item) => {
        obj[item.columnName] = defaultVal(item.entityType)
      })
      this.temp = Object.assign({}, obj) // copy obj
    },
    handleCreate() {
      // 弹出添加框
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    createData() {
      // 保存提交
      this.$refs['dataForm'].validate(() => {
        androidApps.add(this.temp).then(() => {
          this.list.unshift(this.temp)
          this.dialogFormVisible = false
          this.$refs.upload.clearFiles();
          this.$notify({
            title: '成功',
            message: '创建成功',
            type: 'success',
            duration: 2000,
          })
        })
      })
    },
    handleUpdate(row) {
      // 弹出编辑框
      this.temp = Object.assign({}, row) // copy obj
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
      console.log(this.temp);

    },
    updateData() {
      // 更新提交
      this.$refs['dataForm'].validate(() => {
        const tempData = Object.assign({}, this.temp)
        androidApps.update(tempData).then(() => {
          for (const v of this.list) {
            if (v.id === this.temp.id) {
              const index = this.list.indexOf(v)
              this.list.splice(index, 1, this.temp)
              break
            }
          }
          this.dialogFormVisible = false
          this.$refs.upload.clearFiles();
          this.$notify({
            title: '成功',
            message: '更新成功',
            type: 'success',
            duration: 2000,
          })
        })
      })
    },
    handleDelete(rows) {
      // 多行删除
      this.delrows(androidApps, rows)
    },
    checkFileType(file) {
      if (file.name.slice(-4).toLowerCase() != '.apk') {
        this.$notify({
          title: '提示',
          message: '只能上传apk文件',
          type: 'warning',
          duration: 2000
        })
        return false;
      }
      this.fileLoading = this.$loading({ lock: true });
      return true;
    },
    handleFileRemove() {
      this.enableFileBtn = true;
      this.temp.apkUrl = "";
    },
    handleUpload(res) {
      let that = this;

      if (res.code == 200) {
        that.$notify({
          title: '提示',
          message: '上传成功',
          type: 'success',
          duration: 2000
        })
        if (res.result ) {
          that.temp.apkUrl = res.result.filePath;
          that.enableFileBtn = false;
        }
        that.fileLoading.close();
      } else {
        that.$alert(res.message, '上传失败', {
          callback: () => {
            that.fileLoading.close();
            //that.dialogFormVisible = false;
            that.$refs.upload.clearFiles();
          }
        });
      }
    }
  },
}
</script>
<style>
.dialog-mini .el-select {
  width: 100%;
}
</style>
